import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ConfigOptions, ConfigService } from '@wilson/config';
import { Activity, Shift } from '@wilson/interfaces';
import { Observable } from 'rxjs';

export enum ShiftActionsErrorMessages {
  ContainsSharedActivities = 'CONTAINS_SHARED_ACTIVITIES',
}

export interface UpdatedActivityPart {
  id: string;
  startDatetime: Activity['startDatetime'];
  endDatetime: Activity['endDatetime'];
}

export interface UpdatedShiftPart {
  id: string;
  startDate: Shift['startDate'];
  publicationStatus: Shift['publicationStatus'];
  startDatetime: string;
  endDatetime: string;
  activities: UpdatedActivityPart[];
}

export type MoveShiftsResponse = UpdatedShiftPart[];

@Injectable({
  providedIn: 'root',
})
export class ShiftActionsGateway {
  private readonly httpClient = inject(HttpClient);
  private readonly config = inject<ConfigOptions>(ConfigService);

  protected readonly path = 'shift-actions';

  moveShifts(
    shiftIds: string[],
    durationInMinutes: number,
  ): Observable<MoveShiftsResponse> {
    return this.httpClient.patch<MoveShiftsResponse>(
      `${this.config.host}/${this.path}/move`,
      {
        shiftIds,
        durationInMinutes,
      },
    );
  }
}
